export function APICore() {
  return '/go-scrapingmp/v1'
}
export function APICoreScrapingmp() {
  return '/py-scrapingmp/v1'
}
export function APIReportPHP() {
  return '/php-scrapingmp/v1'
}


// WEBPACK FOOTER //
// ./src/utils/servicesApi.js